import { createContext } from 'react';

const User = createContext({});

export { User }